module.exports = __webpack_public_path__ + "img/icon.7105f62b.png";